// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consultor-card {
  margin: 35px 0 8px 0;
  border-radius: 28px;
}
.consultor-card p {
  margin-top: 10px !important;
}
.consultor-card .img-service {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
.consultor-card .img-service span {
  text-align: center;
}
.consultor-card .content-service {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.consultor-card iframe {
  border-radius: 15px;
}
.consultor-card .btn-descargar button {
  width: 100%;
  height: 140px;
  border-radius: 15px;
  background: rgb(122, 107, 232);
  background: linear-gradient(90deg, rgb(122, 107, 232) 0%, rgb(39, 230, 196) 50%);
  border: 0;
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 15px;
}
.consultor-card .btn-descargar button img {
  width: 70px;
  height: 30px;
}
.consultor-card .btn-descargar button span {
  color: white;
  font-size: 13px;
  font-weight: 600;
}
.consultor-card .descargar-archivos button {
  height: 58px !important;
  margin-bottom: 10px;
}
.consultor-card .card-score_and_button .card-score_number {
  background: #41C8FF;
  border-radius: 15px;
  font-size: 20px;
  font-weight: 700;
  color: white;
  min-height: 52px;
  text-align: center;
  padding-top: 11.5px;
}
.consultor-card .card-score_and_button button {
  width: 100%;
  border: 2px solid #41C8FF;
  color: white;
  border-radius: 50rem;
  background: #41C8FF;
  transition: all 0.4s ease-in-out;
}
.consultor-card .card-score_and_button button:hover {
  background: #5ac2ad;
  color: white;
}
.consultor-card .card-score_and_button button a {
  color: white;
}

.bt_file1 {
  height: 60px !important;
}`, "",{"version":3,"sources":["webpack://./src/Views/Service/Components/Card/consultorCard.sass"],"names":[],"mappings":"AAAA;EAEI,oBAAA;EACA,mBAAA;AAAJ;AAEI;EACI,2BAAA;AAAR;AAEI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAAR;AAEQ;EACI,kBAAA;AAAZ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAAR;AAEI;EACI,mBAAA;AAAR;AAGQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gFAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;AADZ;AAGY;EACI,WAAA;EACA,YAAA;AADhB;AAEY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AAAhB;AAGQ;EACI,uBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAFZ;AAIQ;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAFZ;AAIY;EACI,mBAAA;EACA,YAAA;AAFhB;AAGY;EACI,YAAA;AADhB;;AAGA;EACI,uBAAA;AAAJ","sourcesContent":[".consultor-card\n\n    margin: 35px 0 8px 0\n    border-radius: 28px\n\n    & p\n        margin-top: 10px !important\n\n    & .img-service\n        width: 50px\n        height: 50px\n        display: flex\n        align-items: center\n        justify-content: center\n        color: white\n\n        & span\n            text-align: center\n\n    & .content-service\n        display: flex\n        flex-direction: column\n        height: 100%\n\n    & iframe\n        border-radius: 15px\n\n    & .btn-descargar\n        & button\n            width: 100%\n            height: 140px\n            border-radius: 15px\n            background: rgb(122,107,232)\n            background: linear-gradient(90deg, rgba(122,107,232,1) 0%, rgba(39,230,196,1) 50%)\n            border: 0\n            display: inline-flex\n            align-items: flex-end\n            justify-content: center\n            padding-bottom: 15px\n\n            & img\n                width: 70px\n                height: 30px\n            & span\n                color: white\n                font-size: 13px\n                font-weight: 600\n\n    & .descargar-archivos \n        & button \n            height: 58px !important\n            margin-bottom: 10px\n\n    & .card-score_and_button\n        & .card-score_number\n            background: #41C8FF\n            border-radius: 15px\n            font-size: 20px\n            font-weight: 700\n            color: white\n            min-height: 52px\n            text-align: center\n            padding-top: 11.5px\n\n        & button\n            width: 100%\n            border: 2px solid #41C8FF\n            color: white\n            border-radius: 50rem\n            background: #41C8FF\n            transition: all .4s ease-in-out\n\n            &:hover\n                background: #5ac2ad\n                color: white\n            & a\n                color: white\n\n.bt_file1\n    height: 60px !important"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
